export default __webpack_public_path__ + "img/rewards-hero-img-aecaf92aa5706a2758533327cf8681bb.png";